import React from "react";

type TrendTone = "neutral" | "positive" | "negative" | "warning";

export interface StatCardProps {
  label: string;
  value: React.ReactNode;
  helpText?: React.ReactNode;
  changeLabel?: React.ReactNode;
  trendTone?: TrendTone;
  icon?: React.ReactNode;
}

const trendColors: Record<TrendTone, string> = {
  neutral: "#6b7280",
  positive: "#166534",
  negative: "#b91c1c",
  warning: "#92400e",
};

export default function StatCard({
  label,
  value,
  helpText,
  changeLabel,
  trendTone = "neutral",
  icon,
}: StatCardProps) {
  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: 16,
        padding: 20,
        boxShadow: "0 1px 2px rgba(16, 24, 40, 0.04)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: "#6b7280",
              marginBottom: 8,
            }}
          >
            {label}
          </div>

          <div
            style={{
              fontSize: 28,
              lineHeight: 1.2,
              fontWeight: 800,
              color: "#111827",
              wordBreak: "break-word",
            }}
          >
            {value}
          </div>
        </div>

        {icon ? (
          <div
            aria-hidden="true"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 40,
              height: 40,
              borderRadius: 12,
              backgroundColor: "#f9fafb",
              color: "#374151",
              flexShrink: 0,
            }}
          >
            {icon}
          </div>
        ) : null}
      </div>

      {(changeLabel || helpText) && (
        <div style={{ marginTop: 14 }}>
          {changeLabel ? (
            <div
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: trendColors[trendTone],
                marginBottom: helpText ? 6 : 0,
              }}
            >
              {changeLabel}
            </div>
          ) : null}

          {helpText ? (
            <div
              style={{
                fontSize: 13,
                lineHeight: 1.5,
                color: "#6b7280",
              }}
            >
              {helpText}
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
}